import "@/styles/components/site-footer.css";

export default {
  init: () => {
    const siteFooterForm = document.querySelector(".site-footer-form");

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const emailFieldHolder = siteFooterForm.querySelector("#email_address_field_0");
          const emailField = siteFooterForm.querySelector('[type="email"]');
          const submitButton = siteFooterForm.querySelector('[type="submit"]');

          if (emailField) {
            emailField.setAttribute("placeholder", "Email Address");
          }

          if (submitButton) {
            submitButton.innerHTML = `
              <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 11" class="m-auto w-3">
                <path d="M1.1 5.5H11h-.333M7.15 1.65 11 5.5 7.15 9.35" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
              </svg>
            `;

            emailFieldHolder.append(submitButton);
          }

          observer.disconnect();
        }
      }
    });

    observer.observe(siteFooterForm, { childList: true, subtree: true });
  },
};
